<template>
  <v-container fluid grid-list-md>
    <v-card class="mb-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">SA监控</h3>
      </v-card-title>
    </v-card>
    <v-layout row>
      <v-flex xs4>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="fileHeaders"
              :items="files"
              :pagination.sync="filePagination"
              :rows-per-page-items="[10]"
              :total-items="filePagination.totalItems"
              item-key="id"
            >
              <template slot="items" slot-scope="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.createDate }}</td>
                <td>
                  <v-chip
                    :key="c[0]"
                    @click="show(props.item.id, c[0])"
                    outline
                    small
                    v-for="c in props.item.summary"
                  >
                    <strong>{{c[0]||'All'}}:</strong>
                    <span>{{c[1]}}</span>
                  </v-chip>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs8>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="results"
              :pagination.sync="pagination"
              :rows-per-page-items="[10]"
              :total-items="pagination.totalItems"
              class="data"
              item-key="id"
              ref="dTable"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td>
                    {{ props.item.invoiceNo }}
                    <v-icon @click="showHistory(props)" class="ml-2" small>history</v-icon>
                  </td>
                  <td>{{ props.item.doNo }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>{{ props.item.handleFlag }}</td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.errorMsg }}</td>
                </tr>
              </template>
              <template slot="expand" slot-scope="props">
                <v-card style="margin:15px;">
                  <v-card-title>
                    <h1>History of {{props.item.invoiceNo}}</h1>
                  </v-card-title>
                  <v-data-table
                    :headers="historyHeaders"
                    :items="props.item.histories"
                    hide-actions
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{props.item.type}}</td>
                      <td>{{props.item.handleFlag}}</td>
                      <td>{{props.item.status}}</td>
                      <td>{{props.item.errorMsg}}</td>
                      <td>{{props.item.batchNo}}</td>
                      <td>{{props.item.batchSeq}}</td>
                    </template>
                  </v-data-table>
                </v-card>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      id: null,
      status: null,
      fileHeaders: [
        { text: 'id', value: 'id', sortable: false },
        { text: 'createDate', value: 'createDate', sortable: false },
        { text: 'summary', value: 'summary', sortable: false }
      ],
      filePagination: {
        rowsPerPage: 10,
        page: 1
      },
      headers: [
        {
          text: 'Invoice No',
          value: 'invoiceNo',
          sortable: false
        },
        {
          text: 'DO No',
          value: 'doNo',
          sortable: false
        },
        {
          text: 'Type',
          value: 'shipmentType',
          sortable: false
        },
        { text: 'Handle Flag', value: 'handleFlag', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Message', value: 'errorMsg', sortable: false }
      ],
      historyHeaders: [
        {
          text: 'Type',
          value: 'type',
          sortable: false
        },
        { text: 'Handle Flag', value: 'handleFlag', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Message', value: 'errorMsg', sortable: false },
        { text: 'Batch No', value: 'batchNo', sortable: false },
        { text: 'Seq', value: 'batchSeq', sortable: false }
      ],
      pagination: {
        rowsPerPage: 10
      },
      files: [],
      results: []
    }
  },
  methods: {
    loadFiles() {
      this.$http
        .get(`/b2b/sa/monitor/files`, {
          params: {
            page: this.filePagination.page - 1,
            size: 10,
            sort: 'id,desc'
          }
        })
        .then(res => {
          this.filePagination.page = res.data.number + 1
          this.filePagination.rowsPerPage = res.data.size
          this.filePagination.totalItems = res.data.totalElements
          this.files = res.data.content
        })
    },
    show(id, status) {
      this.id = id
      this.status = status
      this.loadData()
    },
    showHistory(props) {
      if (!props.expanded) {
        this.$http
          .get(`/b2b/sa/monitor/invoices/${props.item.invoiceNo}/histories`)
          .then(res => {
            props.item.histories = res.data
            props.expanded = !props.expanded
          })
      } else {
        props.expanded = !props.expanded
      }
    },
    loadData() {
      if (!this.id) return
      this.$refs.dTable.expanded = {}
      this.$http
        .get(`/b2b/sa/monitor/files/${this.id}`, {
          params: {
            status: this.status,
            page: this.pagination.page - 1,
            size: 10,
            sort: 'b2bMeta.batchSeq,asc'
          }
        })
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
        })
    }
  },

  watch: {
    filePagination() {
      this.loadFiles()
    },
    pagination() {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.data /deep/ .v-datatable__expand-col {
  padding: 0px !important;
  height: 0px !important;
}
</style>
